/**
 * Resource endpoints
 */
export default {
    ASSIGNMENTS: 'v1/assignments',
    FLOW_EVENTS: 'v1/flow-events',
};
